<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Blog Author</p>
            <div>
              <el-tooltip content="Insert" placement="top">
                <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click="insert()"
                ></el-button>
              </el-tooltip>  
              <Dialog />  
            </div>           
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/blog-author/Table'
import Dialog from '../components/blog-author/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('blogAuthor', ['loading'])
  },

  methods: {   
    ...mapMutations('blogAuthor', [
      'setDialog',
      'setSelectedAuthor'
    ]),    
    initialAuthor(){
      return {
        id: null,
        name: '',
        description: null,
        bio: null,
        short_bio: null,
        company: null,
        picture: null
      }
    },
    insert(){
      this.setDialog(true)
      this.setSelectedAuthor(this.initialAuthor())
    }

  }  
}
</script>
